import React from "react";
import Meta from "../components/Meta";
import NewsletterForm from "../components/NewsletterForm";

const Page = () => {
  return (
    <div>

      <Meta
        title="Join the Software Talks Community"
        desc=""
      />

      <div className="pt-[5.5rem] lg:pt-24">
        <section className="dark:bg-jacarta-800 relative py-10">

          <div className="container">
            <div className="lg:flex lg:items-center lg:justify-between">
              <div className="lg:w-[20%]"></div>
              <div className="pb-10 lg:w-[60%] lg:py-20 lg:pr-16 text-center">
                <h1 className="text-jacarta-700 font-display mb-2 text-2xl dark:text-white">
                  Join the Community
                </h1>
                <p className="dark:text-jacarta-300 mb-10 text-lg leading-normal">
                  A weekly email with the best of software talks
                </p>
                <NewsletterForm subscriptionList="78922PpZbTScR763spz03fInGw"/>
                <p className="dark:text-jacarta-300 mt-10 text-sm leading-normal">
                  Free 100%, join us and receive one weekly email. No spam, ever.
                </p>
              </div>
              <div className="lg:w-[20%]"></div>

            </div>
          </div>
        </section>

      </div>
    </div>
  );
};

export default Page;
